import * as React from 'react';
import { confirmAlert } from 'react-confirm-alert';
import Footer from 'src/components/layout/Footer/Footer';
import { ApplicationState } from 'src/store';
import { executeClosure } from 'src/store/closure/actions';
import { connect } from 'react-redux';
import LoadingSpinner from 'src/components/utils/LoadingSpinner/LoadinSpinner';
import { history } from 'src';
import { Link } from 'react-router-dom';

interface Props {
  loading: boolean;
  updated: boolean;

  executeClosure: (successCB: () => any) => any;
}

class ClosureView extends React.Component<Props> {
  constructor(props: Props) {
    super(props);

    if (this.props.updated) {
      this.onSuccessfulClosure();
    }
  }

  closureConfirm = () => {
    confirmAlert({
      title: 'Jahresabschluss',
      message: 'Jahresabschluss wirklich durchführen?',
      buttons: [
        {
          label: 'Durchführen',
          onClick: () => this.props.executeClosure(this.onSuccessfulClosure)
        },
        {
          label: 'Abbrechen',
          onClick: () => {
            return;
          }
        }
      ]
    });
  };

  onSuccessfulClosure = () => {
    history.push(history.location.pathname + '/manage');
  };

  public render() {
    const loading = this.props.loading;
    return (
      <div>
        <div className="container">
          <div className="row">
            <h1 style={{ width: '100%' }} className="centered">
              Jahresabschluss
            </h1>
            <button
              type="submit"
              className="centered"
              style={{
                marginTop: '100px',
                marginBottom: '100px',
                marginLeft: 'auto',
                marginRight: 'auto',
                display: 'block'
              }}
              disabled={loading}
              onClick={this.closureConfirm}
            >
              Durchführen
            </button>
            <div style={{ width: '100%' }}>
              <Link to="closure/manage">Veranstaltungszeiten anpassen</Link>
            </div>
            <LoadingSpinner pending={loading} />
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = ({ closure }: ApplicationState) => ({
  loading: closure.loading,
  updated: closure.updated
});

const mapDispatchToProps = (dispatch: any) => ({
  executeClosure: (successCB: () => any) => dispatch(executeClosure(successCB))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ClosureView);



// WEBPACK FOOTER //
// ./src/pages/Management/Closure/ClosureView.tsx